import React, { useState, useEffect } from 'react';
import { coreAPI } from '../../services/api';
import { Link } from 'react-router-dom';

const Home = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [testimonialsRes, clientsRes] = await Promise.all([
          coreAPI.getTestimonials(),
          coreAPI.getClients()
        ]);

        setTestimonials(testimonialsRes.data.results || testimonialsRes.data);
        setClients(clientsRes.data.results || clientsRes.data);
      } catch (error) {
        console.error('Error fetching home page data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  // Testimonial carousel auto-rotation
  useEffect(() => {
    if (testimonials.length > 1) {
      const interval = setInterval(() => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [testimonials.length]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '18px',
        color: 'var(--pink)'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <div className="home">
      {/* Hero Section */}
      <section id="hero-section">
        <div className="container">
          <h1>Let's get you going with a better website.</h1>
          <p className="hero-tagline">Orchestrate creative solutions for your customers.</p>
          <Link to="/contact" className="cta-button">Get Started</Link>
        </div>
      </section>

      <div className="max-width">
        {/* Intro Section */}
        <section id="intro-section" className="container">
          <h2 id="services">Modern Web Solutions, Powered by Data</h2>
          <p>
            We build data-driven websites and web applications powered by state-of-the-art AI models.
            Every solution we deliver is either consulted by or directly engineered by an industry-leading
            Data Science professional, so the intelligence behind your product is never an afterthought.
            <br /><br />
            Whether you need a smarter customer-facing product, an AI-powered support experience, or a
            fully custom web platform built around your data, we can get you there.{' '}
            <Link to="/contact">Let's chat!</Link>
          </p>
        </section>

        {/* Testimonials */}
        {testimonials.length > 0 && (
          <section className="container">
            <h2 id="customers">What Our Customers Say</h2>
            <div className="carousel-container">
              <div className="carousel" style={{
                transform: `translateX(-${currentTestimonial * 100}%)`
              }}>
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="testimonial">
                    <p>
                      <b>"</b>{testimonial.content}<b>"</b><br /><br /> - {testimonial.author_name ? `${testimonial.author_name.charAt(0)}. ${testimonial.author_name.split(' ').slice(1).join(' ')}` : ''}{testimonial.job_title ? `, ${testimonial.job_title}` : ''}{testimonial.company ? `, ${testimonial.company}` : ''}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Client Logos */}
        {clients.length > 0 && (
          <section className="img/Clients">
            <div className="logo-carousel-container">
              <div className="logo-carousel" style={{
                display: 'flex',
                flexWrap: 'nowrap',
                animation: 'scroll-left 30s linear infinite'
              }}>
                {/* Render logos multiple times for infinite scroll effect */}
                {[...Array(6)].map((_, setIndex) => (
                  <React.Fragment key={setIndex}>
                    {clients.map((client) => {
                      // Extract just the Clients/filename.png part from the logo URL
                      const logoPath = client.logo.split('/').slice(-2).join('/');
                      return (
                        <div key={`${setIndex}-${client.id}`} className="logo">
                          <img
                            src={`/img/${logoPath}`}
                            alt={client.name}
                            style={{
                              height: '3vh',
                              filter: 'brightness(0) invert(1)',
                              width: 'auto'
                            }}
                          />
                        </div>
                      );
                    })}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </section>
        )}

      </div>

    </div>
  );
};

export default Home;
